import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

// « Tous les outils » (/outils), dans Gouvernance → Catalogue & outils.
// Sans icône : pas d'entrée automatique en bas du menu (elle est placée à la main, voir nav).
export const toolsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'tools',
      params: {
        path: '/outils',
        // La page porte son propre en-tête (Header) : pas de barre de titre automatique.
        noHeader: true,
        loader: () => import('./ToolsPage').then(m => <m.ToolsPage />),
      },
    }),
  ],
});
